import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function TimeSeriesChart({ tickets }) {
  console.log("tickets in chart ", tickets);
  // Filter only scanned tickets and parse timestamps
  const processedData = useMemo(() => {
    const validScans = tickets
      .filter((t) => t.was_scanned && t.scanned_in_time)
      .map((t) => new Date(t.scanned_in_time).getTime())
      .sort((a, b) => a - b);

    if (validScans.length === 0) return { cumulative: [], perMinute: [] };

    // === 1. Cumulative scans over time ===
    const cumulative = validScans.map((ts, index) => [ts, index + 1]);

    // === 2. Scans per minute (this shows peaks clearly!) ===
    const perMinuteMap = new Map();

    validScans.forEach((ts) => {
      const minute = Math.floor(ts / 60000) * 60000; // Floor to nearest minute
      perMinuteMap.set(minute, (perMinuteMap.get(minute) || 0) + 1);
    });

    const perMinute = Array.from(perMinuteMap.entries())
      .map(([time, count]) => [time, count])
      .sort((a, b) => a[0] - b[0]);

    return { cumulative, perMinute };
  }, [tickets]);

  const options = {
    chart: {
      zoomType: "x",
      animation: false,
      height: 500,
    },
    title: {
      text: "Ticket Scan Peaks — When Are Fans Arriving?",
      style: { color: "#fff" },
    },
    xAxis: {
      type: "datetime",
      title: { text: "Time" },
      labels: { style: { color: "#ccc" } },
    },
    yAxis: [
      {
        title: {
          text: "Scans per Minute",
          style: { color: "#3ea9f7" },
        },
        labels: { style: { color: "#3ea9f7" } },
        opposite: false,
      },
      {
        title: {
          text: "Total Scanned (Cumulative)",
          style: { color: "#777e90" },
        },
        labels: { style: { color: "#777e90" } },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
      xDateFormat: "%H:%M",
    },
    legend: { itemStyle: { color: "#fff" } },
    plotOptions: {
      area: {
        fillOpacity: 0.4,
        marker: { enabled: false },
      },
      column: {
        pointPadding: 0,
        borderWidth: 0,
        groupPadding: 0,
        shadow: false,
      },
    },
    series: [
      {
        name: "Scans per Minute (Peak Detector)",
        type: "column",
        yAxis: 0,
        data: processedData.perMinute,
        color: "#3ea9f7",
        tooltip: { valueDecimals: 0, valueSuffix: " scans/min" },
        pointWidth: 10,
      },
      {
        name: "Cumulative Entry",
        type: "area",
        yAxis: 1,
        data: processedData.cumulative,
        color: "#777e90",
        lineWidth: 3,
        tooltip: { valueSuffix: " total scanned" },
      },
    ],
    credits: { enabled: false },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: ["downloadPNG", "downloadPDF", "separator", "viewData"],
        },
      },
    },
  };

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={options} />
      {/* Optional summary stats */}
      <div style={{ color: "#000c", marginTop: 16, fontFamily: "system-ui" }}>
        <strong>{tickets.filter((s) => s.was_scanned).length}</strong> tickets
        scanned so far
        {" • "}
        Peak minute:{" "}
        <strong>
          {Math.max(...processedData.perMinute.map((p) => p[1]), 0)} scans
        </strong>
        {" • "}
        Event start appears around:{" "}
        {processedData.perMinute.length > 0 && (
          <strong>
            {new Date(processedData.perMinute[0][0]).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </strong>
        )}
      </div>
    </>
  );
}
